class Checkout {
    constructor()
    {
        this.checkoutFormValidation('frm-checkOutSecondForm-checkOutSecondForm');
        this.checkoutFormValidation('frm-upgradeCheckOutNewForm-upgradeCheckOutNewForm');
        this.checkoutFormValidation('frm-renewalForm-renewalForm');
        this.checkoutFormValidation('frm-adminOrderForm-adminOrderForm');
    }
    checkoutFormValidation(formID)
    {
        let form = document.getElementById(formID);
        if (form) {
            this.changeCountry(formID);
            this.initCountrySelect(formID);
            this.initProductsSelect(formID);
            //if(formID === "frm-adminOrderForm-adminOrderForm")
            //    return;


            let excludeVatCompanyID = function () {
                let isEu = $('#'+formID+' select[name=countrySelect]').find(':selected').attr('isEu');
                return isEu == 0;
            }

            let excludeEmail = function () {
                return form.querySelectorAll('input[name=email]').length !== 1;
            }

            let submitButton = form.querySelector('button[type=submit]');
            console.log('Validating form:', formID);
            let validator = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'email': {
                            validators: {
                                notEmpty: {
                                    message: 'Email is required'
                                },
                                regexp: {
                                    regexp: /^(?:[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)])$/,
                                    message: 'Please enter a valid email address',
                                },
                                stringLength: {
                                    max: 45,
                                    message: 'Email cannot be over 45 characters',
                                },
                                remote: {
                                    method: 'POST',
                                    url: '?do=checkOutSecondForm-checkEmail',
                                }
                            }
                        },
                        'address': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    max: 256,
                                    message: 'Address cannot be over 256 characters',
                                },
                            }
                        },
                        'countrySelect': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            }
                        },
                        'company_name': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    max: 45,
                                    message: 'Company name cannot be over 45 characters',
                                }
                            }
                        },
                        'vat_id': {
                            validators: {
                                stringLength: {
                                    max: 20,
                                    message: 'VAT ID cannot be over 20 characters',
                                },
                                regexp: {
                                    regexp: /^((AT)?U[0-9]{8}|(BE)?0[0-9]{9}|(HR)?[0-9]{11}|(BG)?[0-9]{9,10}|(CY)?[0-9]{8}[A-Z]|(CZ)?[0-9]{8,10}|(DE)?[0-9]{9}|(DK)?[0-9]{8}|(EE)?[0-9]{9}|(EL|GR)?[0-9]{9}|(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)?[0-9]{8}|(FR)?[0-9A-Z]{2}[0-9]{9}|(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)?[0-9]{8}|(IE)?[0-9]{7}[A-Z]{1,2}|(IT)?[0-9]{11}|(LT)?([0-9]{9}|[0-9]{12})|(LU)?[0-9]{8}|(LV)?[0-9]{11}|(MT)?[0-9]{8}|(NL)?[0-9]{9}B[0-9]{2}|(PL)?[0-9]{10}|(PT)?[0-9]{9}|(RO)?[0-9]{2,10}|(SE)?[0-9]{12}|(SI)?[0-9]{8}|(SK)?[0-9]{10})?$/,
                                    message: 'VAT ID is invalid.',
                                }
                            }
                        },
                        'company_id': {
                            validators: {
                                stringLength: {
                                    max: 8,
                                    message: 'Company ID cannot be over 8 characters',
                                },
                                regexp: {
                                    regexp: /^[0-9]+$/,
                                    message: 'Only numeric characters are allowed',
                                },
                                callback: {
                                    message: 'This field is required',
                                    callback: function (input) {
                                        let country = $('#'+formID+' select[name=countrySelect]').find(':selected').val();
                                        if (country == 54 && form.querySelector('input[name=vat_id]').value !== '') {
                                            return {
                                                valid: !!input.value
                                            };
                                        }
                                        return {
                                            valid: true
                                        };
                                    }
                                }
                            }
                        },
                        'payment': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            }
                        },
                        'members': {
                            validators: {
                                between: {
                                    min: (formID !== 'frm-checkOutSecondForm-checkOutSecondForm' || $("#individual").length > 0 ? 0 : 5),
                                    max: $('#members_input').attr('max'),
                                    message: 'Members are limited to '+ ((formID === 'frm-checkOutSecondForm-checkOutSecondForm') ? '5-'+$('#members_input').attr('max')+' for the first order.' : '0-'+$('#members_input').attr('max')+'.')+' For more Members, please contact us.',
                                },
                            },
                        },
                        'gateways': {
                            validators: {
                                between: {
                                    min: (formID !== 'frm-checkOutSecondForm-checkOutSecondForm' ? 0 : 1),
                                    max: 10,
                                    message: 'Gateways must be between 1 and 10',
                                },
                            },
                        },
                        'branches': {
                            validators: {
                                between: {
                                    min: 0,
                                    max: 250,
                                    message: 'Branches must be between 0 and 250',
                                },
                            },
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        // Validate fields when clicking the Submit button
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        // Submit the form when all fields are valid
                        defaultSubmit: new FormValidation.plugins.DefaultSubmit(),
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                    excluded: new FormValidation.plugins.Excluded({
                        excluded: function (field, element, elements) {
                            console.log('Excluded form:', field);
                            if (field === 'vat_id' || field === 'company_id') {
                                return excludeVatCompanyID();
                            } else if (field === 'email') {
                                return excludeEmail();
                            }
                            return false;
                        }
                        }),
                    }
                }
            ).on('core.validator.validated', function (e) {
                console.log('Validated field:', e.field, 'Result:', e.result);
                if (!e.result.valid) {
                    // Query all messages
                    const messages = [].slice.call(form.querySelectorAll('[data-field="' + e.field + '"][data-validator]'));
                    messages.forEach((messageEle) => {
                        const validator = messageEle.getAttribute('data-validator');
                        messageEle.style.display = validator === e.validator ? 'block' : 'none';
                    });
                }
            }).on('core.form.validating', function(event) {
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
            }).on('core.form.valid', function(e) {
                // Submit form and remove disabled inputs
                $('input:disabled, select:disabled, textarea:disabled').each(function () {
                    $(this).removeAttr('disabled');
                });
                form.submit();
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
            }).on('core.form.invalid', function(event) {
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
            });
        }
    }
    changeCountry(formID)
    {
        let vatCompanyWrapper = $('#'+formID+' #vatCompanyID_wrapper');
        const hideVatCompany = function () {
            vatCompanyWrapper.addClass('d-none');
            vatCompanyWrapper.find('input[name="vat_id"]').attr('disabled', true);
            vatCompanyWrapper.find('input[name="company_id"]').attr('disabled', true);
        }
        const showVatCompany = function () {
            vatCompanyWrapper.removeClass('d-none');
            vatCompanyWrapper.find('input[name="vat_id"]').attr('disabled', false);
            vatCompanyWrapper.find('input[name="company_id"]').attr('disabled', false);
        }
        const showVat = function () {
            vatCompanyWrapper.removeClass('d-none');
            vatCompanyWrapper.find('input[name="vat_id"]').attr('disabled', false);
            vatCompanyWrapper.find('input[name="company_id"]').attr('disabled', true);
        }

        $('#'+formID+' select[name=countrySelect]').on('select2:select', function (e) {
            const isEu = e.params.data.element.attributes.isEu.value;
            const value = e.params.data.element.attributes.value.value;
            if (value == 54) {
                showVatCompany();
            } else if (isEu == 1) {
                showVat();
            } else {
                hideVatCompany();
            }
        }).on('change', function (e) {
            const optionSelected = $("option:selected", this);
            if (optionSelected.attr('isEU') == 1) {
                showVatCompany()
            } else {
                hideVatCompany();
            }
        });
    }
    initCountrySelect(formID)
    {
        var optionFormat = function (item) {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            let template = '';
            template += '<div class="d-flex align-items-center" data-cy="country">';
            template += item.element.getAttribute('data-kt-rich-content-country');
            template += '<div class="d-flex flex-column">';
            template += '<span class="fs-6 fw-bold lh-1 text-primary">' + item.text + '</span>';
            template += '</div>';
            template += '</div>';
            span.innerHTML = template;
            return $(span);
        };

        $('#'+formID+' select[name=countrySelect]').select2({
            placeholder: 'Nothing selected',
            templateSelection: optionFormat,
            templateResult: optionFormat
        });
    }
    initProductsSelect(formID)
    {
        $('#'+formID+' [name=productSelection]').select2({
            dropdownAutoWidth : true,
            width: 'auto',
            minimumResultsForSearch: -1
        });
        $('#'+formID+' [name=duration]').select2({
            dropdownAutoWidth : true,
            width: 'auto',
            minimumResultsForSearch: -1
        });
    }
}
window.Checkout = Checkout;